var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hexa-logo"},[_c('a',{staticClass:"d-flex align-center",on:{"click":_vm.redirect}},[_c('img',{attrs:{"src":require("@/assets/heax-logo.svg")}}),_c('h3',[_vm._v("Hexageo")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }